/*
 Displays a row of books with an overlay on the last book displaying the number
 of additional books. Only used for the UserChallenge (reading challenge) and
 ReadingYear (your year in books) updates
*/
import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import classNames from "classnames";
import { map, take } from "lodash";

export const MAX_DISPLAYED_BOOKS = 4;

export default GrComponentFactory.createClass({
  displayName: "BookCoverRow",
  propTypes: {
    numBooksRead: React.PropTypes.number.isRequired,
    books: React.PropTypes.arrayOf(GrPropTypes.book()),
    url: React.PropTypes.string.isRequired,
  },

  isLastBook(index) {
    if (this.props.books.length <= MAX_DISPLAYED_BOOKS) {
      return index === this.props.books.length - 1;
    } else {
      return index === MAX_DISPLAYED_BOOKS - 1;
    }
  },

  shouldRenderLastBookCoverOverlay(index) {
    return this.isLastBook(index) &&
           this.props.numBooksRead > MAX_DISPLAYED_BOOKS;
  },

  getBookCoverRowClasses(index) {
    return classNames("bookCoverRow__image",
                      { bookCoverRow__lastCompletedBookOverlay:
                       this.shouldRenderLastBookCoverOverlay(index) });
  },

  getBookImageClasses(index) {
    return classNames("gr-book__image",
                      { "gr-book__image--noRightMargin": this.isLastBook(index) });
  },

  renderLastBookCoverOverlay() {
    return <div className="bookCoverRow__leftoverBookCount">
             {`+${this.props.numBooksRead - MAX_DISPLAYED_BOOKS}`}
           </div>;
  },

  render() {
    return <div className="bookCoverRow">
             { map(take(this.props.books, MAX_DISPLAYED_BOOKS), (book, i) => {
               const bookImageUrl = this.shouldRenderLastBookCoverOverlay(i) ?
                 this.props.url :
                 book.bookUrl;
               return <a key={book.bookId} href={bookImageUrl}>
                          <div className={this.getBookCoverRowClasses(i)}>
                            <img alt={book.title}
                                 className={this.getBookImageClasses(i)}
                                 src={book.imageUrl} />
                            { this.shouldRenderLastBookCoverOverlay(i) ?
                              this.renderLastBookCoverOverlay() :
                              null
                            }
                          </div>
                        </a>;
             })
             }
           </div>;
  },
});
